export default "__VITE_ASSET__DojX7mXi__"